import { useState } from "react";
import { useFormik } from "formik";
import CreateLoginForm from "@serie3/common/Form/Login/CreateLoginForm";
import { Form, Modal } from "react-bootstrap";

const LoginModal = ({ show, setShow, setShowRegister, setShowForgot, title }) => {
  const [showLoginError, setShowLoginError] = useState(false);

  const closeModal = () => setShow(false);

  const loginFormiForm = CreateLoginForm(setShowLoginError, closeModal);
  const formik = useFormik(loginFormiForm);

  const showSignupForm = () => { setShow(false); setShowRegister(true); };
  const setShowForgotModal = () => { setShow(false); setShowForgot(true); };

  return (
    <Modal
      size="md"
      show={show}
      onShow={() => setShowLoginError(false)}
      onHide={() => setShow(false)}
      centered
      animation={false}
      dialogClassName="lp-modal"
    >
      <Modal.Header closeButton className="lp-modal-header" />
      <Modal.Body className="lp-modal-body">
        <h2 className="lp-modal-title">{title ?? "Welcome back"}</h2>
        <p className="lp-modal-subtitle">Sign in to your account</p>

        <Form onSubmit={formik.handleSubmit}>
          <Form.Group className="lp-form-group" controlId="username">
            <Form.Label className="lp-form-label">Email</Form.Label>
            <Form.Control
              type="email"
              name="username"
              placeholder="you@example.com"
              onChange={formik.handleChange}
              value={formik.values.username}
              isInvalid={!!formik.errors.username}
              className="lp-form-input"
            />
            <Form.Control.Feedback type="invalid">{formik.errors.username}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="lp-form-group" controlId="password">
            <Form.Label className="lp-form-label">Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="••••••••"
              onChange={formik.handleChange}
              value={formik.values.password}
              isInvalid={!!formik.errors.password}
              className="lp-form-input"
            />
            <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
          </Form.Group>

          {showLoginError && (
            <div className="lp-alert lp-alert-error">
              Incorrect email or password. Please try again.
            </div>
          )}

          {window.location.hostname === "demo.freelancersplace.net" && (
            <div className="lp-alert lp-alert-warning">
              Demo data resets every 30 minutes. Do not use real data.
            </div>
          )}

          <button
            type="submit"
            className="lp-form-submit"
            onClick={() => setShowLoginError(false)}
          >
            Sign in
          </button>

          {window.location.hostname !== "demo.freelancersplace.net" && (
            <p style={{ textAlign: "center", marginTop: "0.75rem", marginBottom: 0 }}>
              <span className="lp-form-link" onClick={setShowForgotModal}>
                Forgot password?
              </span>
            </p>
          )}
        </Form>

        {window.location.hostname !== "demo.freelancersplace.net" && (
          <p className="lp-modal-footer-text">
            Don't have an account?{" "}
            <span className="lp-form-link" onClick={showSignupForm}>
              Sign up free
            </span>
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
